import { removeDupes, cleanObject } from '../utils/helpers';

const customFields = (state = {
    items: [],
    fetchInfo: {
        team: {},
        project: {}
    }
}, action) => {
    if (action.error) {
        return state;
    }

    switch (action.type) {
        case 'TEAM_CHANGE':
        case 'RESET_STORE':
            return {
                items: [],
                fetchInfo: {
                    team: {},
                    project: {}
                }
            };

        case 'CUSTOM_FIELDS_FETCH_REQUESTED':
            if (action.payload.projectId) {
                return Object.assign({}, state, {
                    fetchInfo: {
                        ...state.fetchInfo,
                        project: {
                            ...state.fetchInfo.project,
                            [action.payload.projectId]: {
                                fetched: false,
                                loading: true
                            }
                        }
                    }
                });
            }

            return Object.assign({}, state, {
                fetchInfo: {
                    ...state.fetchInfo,
                    team: {
                        ...state.fetchInfo.team,
                        loading: true
                    }
                }
            });

        case 'CUSTOM_FIELDS_FETCH_SUCCEEDED': {
            const items = removeDupes([...action.payload.customFields, ...state.items])

            if (action.payload.projectId) {
                return Object.assign({}, state, {
                    items,
                    fetchInfo: {
                        ...state.fetchInfo,
                        project: {
                            ...state.fetchInfo.project,
                            [action.payload.projectId]: {
                                fetched: true,
                                loading: false
                            }
                        }
                    }
                });
            }

            return Object.assign({}, state, {
                items,
                fetchInfo: {
                    ...state.fetchInfo,
                    team: {
                        ...state.fetchInfo.team,
                        loading: false,
                        fetched: true
                    }
                }
            });
        }

        case 'CUSTOM_FIELDS_FETCH_FAILED':
            return Object.assign({}, state, {
                fetchInfo: {
                    ...state.fetchInfo,
                    team: {
                        ...state.fetchInfo.team,
                        loading: false,
                        error: true
                    }
                }
            });

        case 'CUSTOM_FIELD_CREATE_REQUESTED':
        case 'CUSTOM_FIELD_ADD_SOCKET':
            if (action.payload.customField.fieldId) {
                return Object.assign({}, state, {
                    items: [...state.items].map(field => {
                        if (field.id === action.payload.customField.fieldId) {
                            return {
                                ...field,
                                associations: [...field.associations, action.payload.customField.associations[0]],
                                projects: [...field.projects, action.payload.customField.projectId],
                            }
                        }

                        return field;
                    })
                });
            }
            return Object.assign({}, state, {
                items: removeDupes([...state.items, action.payload.customField])
            });

        case 'CUSTOM_FIELD_CREATE_FAILED':
            return Object.assign({}, state, {
                items: state.items.filter(customField => customField !== action.payload.fragment)
            });

        case 'CUSTOM_FIELD_CREATE_SUCCEEDED':
            return Object.assign({}, state, {
                items: state.items
                    .map(customField => {
                        if (customField === action.payload.fragment) {
                            return {
                                ...customField,
                                id: action.payload.customFieldId,
                                options: action.payload.options
                            }
                        }

                        return customField;
                    })
            });

        case 'CUSTOM_FIELD_UPDATE_REQUESTED':
        case 'CUSTOM_FIELD_UPDATE_SOCKET':
            return Object.assign({}, state, {
                items: [...state.items].map(customField => {
                    if (customField.id === action.payload.customFieldId) {
                        return Object.assign({}, customField, cleanObject(action.payload.customFieldProps || action.payload.customField));
                    }

                    return customField;
                })
            });

        case 'CUSTOM_FIELD_REMOVE_REQUESTED':
        case 'CUSTOM_FIELD_REMOVE_SOCKET':
            return Object.assign({}, state, {
                items: [...state.items].map(customField => {
                    if (customField.id === action.payload.customFieldId) {
                        return {
                            id: customField.id,
                            removed: true
                        };
                    }

                    if (customField.dependency === action.payload.customFieldId) {
                        return {
                            ...customField,
                            dependency: undefined
                        }
                    }

                    return customField;
                })
            });

        default:
            return state;
    }
}

export default customFields;
